import { History } from "@mui/icons-material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { errors, IRydeProcess } from "@ryde/shared";

import { ProcessesGridRow } from "./processes-grid-row";
import { processesHeaders } from "./processes-grid.models";

interface IProcessesGridProps {
  processes: IRydeProcess[];
}

export const ProcessesGrid: FC<IProcessesGridProps> = ({ processes }) => {
  const { t } = useTranslation();

  if (!processes?.length) {
    return (
      <div className="processes-history__empty-state">
        <div className="processes-history__empty-state-message">
          <History className="processes-history__empty-state-icon" />
          {t(errors.processes.notFoundProcessRecords)}
        </div>
      </div>
    );
  }

  return (
    <div className="processes-history__grid-wrapper">
      <div className="processes-history__grid">
        <div className="processes-history__grid-header">
          <div className="processes-history__grid-header-cell processes-history__grid-header-cell_expanded"></div>
          {Object.entries(processesHeaders).map(([key, translationKey]) => (
            <div key={key} className="processes-history__grid-header-cell">
              {t(translationKey)}
            </div>
          ))}
        </div>

        <div className="processes-history__grid-body">
          {processes?.map(process => (
            <ProcessesGridRow key={process.id} process={process} />
          ))}
        </div>
      </div>
    </div>
  );
};
